<template>
  <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light" id="sidenav-main">
    <div class="container-fluid">

      <!-- Mobile Header: Toggler + Avatar -->
      <div class="d-flex justify-content-between align-items-center w-100 d-md-none">
        <ul class="nav align-items-center ml-auto">

          <!-- Hamburger Icon -->
          <navbar-toggle-button @click.native="showSidebar" class="mobile-toggle" />
          <!-- Profile Avatar -->
          <base-dropdown class="nav-item" menu-on-right tag="li" title-tag="a">
            <a slot="title-container" class="nav-link" href="javascript:void(0)" role="button">
              <div class="media align-items-center">
                <span class="avatar avatar-sm rounded-circle">
                  <i class="ni ni-single-02 text-white avatar-img"></i>
                </span>
              </div>
            </a>

            <b-dropdown-header class="noti-title">
              <h6 class="text-overflow m-0">SELAMAT DATANG  {{ userName }}</h6>
            </b-dropdown-header>

            <b-dropdown-item-button @click="logout">
              <i class="ni ni-user-run"></i>
              <span>Log Keluar</span>
            </b-dropdown-item-button>
          </base-dropdown>

        </ul>
      </div>

      <!-- Logo (Desktop only) -->
      <div class="logo-container d-none d-md-block">
        <router-link class="navbar-brand" to="/">
          <img :src="logo" class="navbar-brand-img" alt="Logo" style="transform: scale(2.1);">
        </router-link>
      </div>

      <!-- Sidebar Links -->
      <slot></slot>
      <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img :src="logo">
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button @click.native="closeSidebar" />
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links"></slot>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import NavbarToggleButton from '@/components/NavbarToggleButton';
import { BDropdownItemButton, BDropdownHeader } from 'bootstrap-vue';

export default {
  name: 'sidebar',
  components: {
    NavbarToggleButton,
    BDropdownItemButton,
    BDropdownHeader
  },
  props: {
    logo: {
      type: String,
      default: 'img/brand/hemat_c.png'
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    let userName = 'User';
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      if (userData && userData.nama) {
        userName = userData.nama.trim();
      }
    } catch (e) {
      console.warn('Unable to parse user data from localStorage:', e);
    }

    return {
      userName,
      isMobile: window.innerWidth <= 767.98
    };
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true);
    },
    logout() {
      localStorage.clear();
      this.$store.commit('logoff');
      this.$router.push('/login');
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>

<style scoped>
/* Desktop View */
.navbar {
  background-color: #ffffff !important;
}

.logo-container {
  background-color: #1e3a8a;
  width: 130%;
  padding: 1rem;
  text-align: center;
  margin-bottom: 0rem;
  margin-top: -2rem;
  margin-left: -2rem;
}

.navbar-brand-img {
  max-height: 120px;
  width: auto;
  object-fit: contain;
}

/* Mobile View */
@media (max-width: 767.98px) {
  #sidenav-main.navbar {
    background-color: #1e3a8a !important;
  }

  .d-flex.justify-content-between {
    width: 100%;
    justify-content: flex-end;
  }

  .nav.align-items-center.ml-auto {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
  }

  .mobile-toggle {
    margin-left: 10px;
  }

  .mobile-toggle >>> .navbar-toggler-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
  }
}

/* UX Enhancement */
.avatar {
  cursor: pointer;
}

.avatar:hover {
  opacity: 0.8;
}
</style>
